document.addEventListener("DOMContentLoaded", () => {
  /*
   * Number of paid embroidery locations currently selected.
   *
   * This remains zero on products that do not use the
   * hat builder.
   */
  let paidLocationCount = 0;

  /*
   * Additional embroidery pricing per location:
   *
   * 1 total additional location: $6 each
   * 2–10 total locations:        $5 each
   * 11–25 total locations:       $4 each
   * 26+ total locations:         $3 each
   */
  const EMBROIDERY_PRICE_TIERS = [
    {
      min: 1,
      max: 1,
      unitPriceCents: 600
    },
    {
      min: 2,
      max: 10,
      unitPriceCents: 500
    },
    {
      min: 11,
      max: 25,
      unitPriceCents: 400
    },
    {
      min: 26,
      max: Infinity,
      unitPriceCents: 300
    }
  ];

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getEmbroideryPricePerLocation(
    totalEmbroideryUnits
  ) {
    if (totalEmbroideryUnits < 1) {
      return 0;
    }

    const matchingTier =
      EMBROIDERY_PRICE_TIERS.find(tier => {
        return (
          totalEmbroideryUnits >= tier.min &&
          totalEmbroideryUnits <= tier.max
        );
      });

    if (matchingTier) {
      return matchingTier.unitPriceCents;
    }

    return 300;
  }

  /*
   * Calculates the additional embroidery cost per hat.
   *
   * Example:
   *
   * 6 hats
   * Left + Rear selected
   *
   * 6 × 2 = 12 additional embroidery locations
   * 12 locations use the $4 tier
   * 2 paid locations × $4 = $8 extra per hat
   */
  function getEmbroideryChargePerUnit(
    quantity,
    selectedPaidLocations
  ) {
    if (selectedPaidLocations < 1) {
      return 0;
    }

    const totalEmbroideryUnits =
      quantity * selectedPaidLocations;

    const pricePerLocation =
      getEmbroideryPricePerLocation(
        totalEmbroideryUnits
      );

    return (
      selectedPaidLocations * pricePerLocation
    );
  }

  function getCurrentQuantity() {
    const quantityInput = document.querySelector(
      'product-form input[name="quantity"], ' +
      'form[data-type="add-to-cart-form"] ' +
      'input[name="quantity"], ' +
      'input[name="quantity"]'
    );

    return Math.max(
      1,
      parseInt(quantityInput?.value, 10) || 1
    );
  }

  function updateQuantityDiscountTable(quantity) {
    const discountTables =
      document.querySelectorAll(
        "[data-quantity-discounts]"
      );

    discountTables.forEach(table => {
      const productPrice = parseInt(
        table.dataset.productPrice,
        10
      );

      if (!Number.isFinite(productPrice)) {
        return;
      }

      const tableGrid = table.querySelector(
        ".quantity-discounts__table"
      );

      const rows = Array.from(
        table.querySelectorAll(
          ".quantity-discounts__row"
        )
      );

      /*
       * Metaobject entries are not guaranteed to be
       * returned in numerical order, so sort the cards
       * by their minimum quantity.
       */
      rows.sort((a, b) => {
        return (
          parseInt(a.dataset.min, 10) -
          parseInt(b.dataset.min, 10)
        );
      });

      rows.forEach(row => {
        if (tableGrid) {
          tableGrid.appendChild(row);
        }

        const min = Math.max(
          1,
          parseInt(row.dataset.min, 10) || 1
        );

        const parsedMax = parseInt(
          row.dataset.max,
          10
        );

        const max = Number.isFinite(parsedMax)
          ? parsedMax
          : Infinity;

        const discount =
          parseFloat(row.dataset.discount) || 0;

        /*
         * The active card uses the customer's exact
         * quantity. Other cards use the minimum quantity
         * represented by that card.
         *
         * This lets every card show the correct estimated
         * embroidery tier for its quantity range.
         */
        const isActive =
          quantity >= min &&
          quantity <= max;

        const quantityForCard = isActive
          ? quantity
          : min;

        const discountedHatPrice =
          productPrice *
          (1 - discount / 100);

        const embroideryCharge =
          getEmbroideryChargePerUnit(
            quantityForCard,
            paidLocationCount
          );

        const combinedUnitPrice = Math.round(
          discountedHatPrice +
          embroideryCharge
        );

        const priceEl = row.querySelector(
          ".quantity-discounts__price"
        );

        if (priceEl) {
          priceEl.textContent =
            formatMoney(combinedUnitPrice);
        }

        row.classList.toggle(
          "is-active",
          isActive
        );
      });
    });
  }

  function refreshQuantityDiscountTable() {
    updateQuantityDiscountTable(
      getCurrentQuantity()
    );
  }

  function initializeQuantityInputs() {
    const quantityInputs =
      document.querySelectorAll(
        'input[name="quantity"]'
      );

    quantityInputs.forEach(input => {
      input.addEventListener(
        "change",
        refreshQuantityDiscountTable
      );

      input.addEventListener(
        "input",
        refreshQuantityDiscountTable
      );

      /*
       * Dawn's plus and minus buttons sometimes update
       * the input immediately before the change event.
       */
      const quantityContainer = input.closest(
        "quantity-input, .quantity"
      );

      quantityContainer?.addEventListener(
        "click",
        () => {
          window.setTimeout(
            refreshQuantityDiscountTable,
            0
          );
        }
      );
    });
  }

  /*
   * Listen for paid embroidery selection changes
   * from hat-builder.js.
   */
  document.addEventListener(
    "hatBuilder:addonsChanged",
    event => {
      paidLocationCount = Math.max(
        0,
        parseInt(
          event.detail?.paidLocationCount,
          10
        ) || 0
      );

      refreshQuantityDiscountTable();
    }
  );

  initializeQuantityInputs();
  refreshQuantityDiscountTable();
});